import { render, staticRenderFns } from "./gb-whatsapp-old-version.vue?vue&type=template&id=7d54186c&scoped=true"
import script from "./gb-whatsapp-old-version.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-old-version.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-old-version.vue?vue&type=style&index=0&id=7d54186c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54186c",
  null
  
)

export default component.exports